import { useQuery } from '@tanstack/react-query';
import api from '@v2/lib/api';
import type { PloomesDealDetail } from '../types';

export type DealRelationsPayload = Pick<
    PloomesDealDetail,
    'ploomes_interactions' | 'ploomes_tasks' | 'ploomes_orders' | 'ploomes_attachments'
>;

export function dealRelationsQueryKey(dealId: number) {
    return ['ploomes-deal-relations', dealId] as const;
}

export function useDealRelations(dealId: number) {
    return useQuery({
        queryKey: dealRelationsQueryKey(dealId),
        enabled: dealId > 0,
        staleTime: 60_000,
        queryFn: async ({ signal }) => {
            const { data } = await api.get<{ data: DealRelationsPayload }>(
                `/ploomes-deals/${dealId}/relations`,
                { signal, timeout: 20_000 },
            );
            return data.data;
        },
    });
}
